export const parseUrlInt = (value: string | null): number | undefined => {
  if (!value) return undefined;
  const n = parseInt(value, 10);
  return Number.isFinite(n) ? n : undefined;
};

export const parseUrlStatus = (
  value: string | null,
  allowed: readonly string[],
  fallback = "all"
): string => {
  if (!value) return fallback;
  return allowed.includes(value) ? value : fallback;
};

export const parseUrlHasContainer = (
  value: string | null
): "yes" | "no" | undefined => {
  if (value === "yes" || value === "no") return value;
  return undefined;
};

const PICKUP_FILTER_VALUES = [
  "overdue",
  "due_soon",
  "upcoming",
  "awaiting_warehouse",
  "received",
  "no_pickup_date",
] as const;

export const parseUrlPickupFilter = (
  value: string | null
): (typeof PICKUP_FILTER_VALUES)[number] | undefined => {
  if (!value) return undefined;
  return (PICKUP_FILTER_VALUES as readonly string[]).includes(value)
    ? (value as (typeof PICKUP_FILTER_VALUES)[number])
    : undefined;
};

export const parseUrlServiceLevel = (
  value: string | null
): "budget" | "premium" | undefined => {
  if (value === "budget" || value === "premium") return value;
  return undefined;
};

export const setUrlParams = (
  setSearchParams: (
    next: URLSearchParams | Record<string, string>,
    opts?: { replace?: boolean }
  ) => void,
  entries: Record<string, string | number | undefined | null>
) => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(entries)) {
    if (value === undefined || value === null || value === "") continue;
    params.set(key, String(value));
  }
  setSearchParams(params, { replace: true });
};
